import { useEffect, useState } from "react"
import { GetFavoriteProducts } from "../../../Services/ProductService"
import { toast } from "react-toastify"
import { useAuth } from "../../../Providers/AuthProvider"
import { useConfig } from "../../../Providers/ConfigProvider"

const useGetFavoriteProducts = (setPending) => {
  const { authState } = useAuth()
  const [favoriteProducts, setFavoriteProducts] = useState([])

  const { api } = useConfig()

  useEffect(() => {
    handleGetFavoriteProducts()
  }, [])

  const handleGetFavoriteProducts = () => {
    setPending(true)
    let custId = authState.custId
    GetFavoriteProducts(api, custId, authState.siteId, authState.whId).then(res => {
      setFavoriteProducts(res.data)
      setPending(false)
    })
      .catch(e => {
        console.log(e)
        toast.error('Bląd w trakcie pobierania ulubionych produktów')
        setFavoriteProducts([])
        setPending(false)
      })
  }
  return { favoriteProducts, handleGetFavoriteProducts }
}

export default useGetFavoriteProducts